import { MediaQueries } from 'UI'

export default theme => ({
  mainIcon: {
    fontSize: 24,
    color: theme.success[0],
    backgroundColor: theme.success[300],
    borderRadius: 8,
    padding: 20,
    marginBottom: 32
  },
  checkIcon: {
    color: theme.secondary[0],
    marginRight: 4,
    fontSize: 12
  },
  controlContainer: {
    display: 'flex',
    flexDirection: 'row'
  },
  [`${MediaQueries.tablet}`]: {
    controlContainer: {
      flexDirection: 'column',
      marginTop: 'auto'
    }
  },
  [`${MediaQueries.mobile}`]: {
    controlContainer: {
      flexDirection: 'column',
      marginTop: 'auto'
    }
  }
})
